module.exports = {
  title: '管易ERP对接设置',
  route: {
    path: '/seller-goods-manage',
    children: {
      path: 'gy-erp-set',
    },
  },
};
